import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCustomerServiceManagementFeaturesRoute: InvariantJiraRoute = {
	name: 'project-settings-customer-service-management-features',
	path: '/jira/customer-service-management/projects/:projectKey/settings/features',
	exact: true,
};
